import { render, staticRenderFns } from "./iconCamera.vue?vue&type=template&id=04643a5d"
import script from "./iconCamera.vue?vue&type=script&lang=js"
export * from "./iconCamera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports